import React, { Component } from 'react';

class GetImposterApp extends Component {
    state = {};
    getMobileOperatingSystem() {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        // Detect Android
        const isAndroid = /Android/.test(navigator.userAgent);
        
        // Example usage
        if (isIOS) {
            window.location.href = "https://apps.apple.com/lb/app/imposter-party-game/id6737323876";
        } else if (isAndroid) {
            window.location.href = "https://play.google.com/store/apps/details?id=com.imposter";
        } else {
            window.location.href = "https://imposter-game.web.app/";
        }
    }
    render() {
        this.getMobileOperatingSystem()
        return (
               <div></div>
        );
    }
}

export default GetImposterApp;
